(function (angular) {
    angular.module('bizPartEngage').service('core.portal.service', portalService);

    portalService.$inject = ["$http", "$q", "$state"];

    function portalService($http, $q, $state) {
    	var apiPath = siteRootPath + "api/portal/";
    	var settingsPromise = [];

    	return {
    		ClearPromiseCache: ClearPromiseCache,
    		GetPortalSetting: GetPortalSetting,
        };

    	function ClearPromiseCache() {
    		settingsPromise = null;
    	}


    	function GetPortalSetting(key, force) {
    		if (!force && settingsPromise[key]) return settingsPromise[key];

    		settingsPromise[key] = $http.get(apiPath + 'GetPortalSettingValue?' + $.param({key: key}));
    		return settingsPromise[key];
    	}
    }
})(window.angular);
